import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=aa11b0b6&scoped=true"
import script from "./Copy.vue?vue&type=script&lang=ts"
export * from "./Copy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa11b0b6",
  null
  
)

export default component.exports